import React from "react";
import tw, { styled, css } from "twin.macro";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";

const Nav = tw.nav`flex flex-col w-full relative`;

const ItemStyles = () => [tw`relative text-white`];

const TopItem = styled.div(({ current }) => [
  ItemStyles,
  tw`font-gothic tracking-widest uppercase text-center [&>ul]:pt-2`,
  css`
    &:hover {
      ${tw`text-primary`}
      &:after {
        ${tw`h-[1rem]`}
      }
      & > ul {
        ${tw`block`}
      }
    }
    & > a {
      ${tw`relative flex w-full px-6 py-1 leading-none after:(content[''] w-[calc(100% - 3rem)] absolute left-0 right-0 mx-auto top-full h-0 bg-primary)`}
      ${current && tw`after:h-2`}
    }
    ${current && tw`text-primary`}
  `,
]);

const ChildItem = styled.div(
  [
    ItemStyles,
    tw`bg-dark font-mont relative text-base tracking-normal capitalize`,
  ],
  css`
    &:hover {
      ${tw`bg-primary`}
      & > ul {
        ${tw`block`}
      }
    }
    & > a {
      ${tw`flex w-full px-2 py-1`}
    }
  `
);

const List = tw.ul`flex items-center justify-center`;
const Children = styled.ul(({ flip }) => [
  tw`absolute hidden top-full whitespace-nowrap [ul]:top-0`,
  !flip ? tw`right-0 [ul]:right-full` : tw`left-0 [ul]:left-full`,
]);

const DesktopNavigation = ({ menu, ...rest }) => {
  const { pathname } = useLocation();
  const listItems = (items, flip = false, child = false) =>
    items.map((item, i) => {
      const Item = !!item.parentId ? ChildItem : TopItem;
      flip = child ? flip : i < 4 ? true : false;
      return (
        <Item key={i} target={item.target} current={pathname === item.path}>
          <Link to={item.path}>{item.label}</Link>
          {!!item.children && item.children.length > 0 && (
            <Children flip={flip}>
              {listItems(item.children, flip, true)}
            </Children>
          )}
        </Item>
      );
    });
  return (
    <Nav {...rest}>
      <List>{listItems(menu)}</List>
    </Nav>
  );
};

export default DesktopNavigation;
